/** @jsxImportSource @emotion/react */

import { formatCurrency } from "helpers/formatCurrency";
import { useRef } from "react";

import { useGetBalanceDV } from "api/user/query";
import { GameMenuStyle } from "./index.style";

function GameMenu() {
  const { data } = useGetBalanceDV();

  const modalRef = useRef<HTMLLIElement | null>(null);
  return (
    <li ref={modalRef} css={GameMenuStyle.index} id={"GameMenu"}>
      <div className="btn_memberPMenu">
        <span className="value">
          ${" "}
          <span className="ng-binding">
            {formatCurrency(Math.trunc(Number(data?.main_balance || 0))) || 0}
          </span>
        </span>
      </div>
    </li>
  );
}

export default GameMenu;
